import { render, staticRenderFns } from "./PageFeed.vue?vue&type=template&id=f780f05c&scoped=true&"
import script from "./PageFeed.vue?vue&type=script&lang=js&"
export * from "./PageFeed.vue?vue&type=script&lang=js&"
import style0 from "./PageFeed.vue?vue&type=style&index=0&id=f780f05c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f780f05c",
  null
  
)

export default component.exports